import { SETTINGS_BODY_DIV } from "../../../../assets/styles/classes-constants";
import { SettingsItemEnum } from "../../../../assets/utils/data/items";
import { BodyDiv } from "../../../../components/components-style";
import { Block } from "../../main";
import { UserImage } from "./profile-tab";
import userImage from "../../../../assets/images/user-image.png";
import deleteIcon from "../../../../assets/images/icons/delete-icon.svg";
import { MediumText, TextBody } from "../../../../components/typography";
import { Button } from "../../../../components/ui/button";
import { COLORS } from "../../../../assets/utils/enums/colors";
import { useNavigate, useOutletContext } from "react-router-dom";

type ProfileOutletContext = {
  deleteActionWindow: () => void;
  firstName: string;
  lastName: string;
  email: string;
};

export default function ViewProfile() {
  const { deleteActionWindow, firstName, lastName, email } =
    useOutletContext<ProfileOutletContext>();
  const navigate = useNavigate();
  return (
    <BodyDiv
      className={`${SETTINGS_BODY_DIV} justify-content-between`}
      $isPadding={true}
    >
      <Block
        className={`w-100 d-flex align-items-center justify-content-between`}
      >
        <UserImage $operationItem={SettingsItemEnum.VIEW_PROFILE}>
          <img src={userImage} alt="user-image" />

          <span>
            <MediumText>
              {firstName} {lastName}
            </MediumText>
            <TextBody>{email}</TextBody>
          </span>
        </UserImage>

        <Button
          bgcolor={COLORS.secondary1}
          txtcolor={COLORS.white}
          brcolor={"transparent"}
          width="auto"
          brradius="12px"
          className="mt-3"
          type="small"
          onClick={() => navigate("/settings/profile/edit")}
        >
          <MediumText>Редагувати профіль</MediumText>
        </Button>
      </Block>
      <Block
        className={`w-100 d-flex align-items-center justify-content-between`}
      >
        <Button
          bgcolor={"transparent"}
          txtcolor={COLORS.secondary1}
          brcolor={"transparent"}
          type="large"
          width="auto"
          className="d-flex align-items-center gap-2 text"
        >
          <img src={deleteIcon} alt="delete-icon" />
          <MediumText>Видалити профіль</MediumText>
        </Button>
        <Button
          bgcolor={COLORS.warning}
          txtcolor={COLORS.white}
          brcolor={"transparent"}
          type="small"
          width="auto"
          className="d-flex align-items-center gap-2"
          onClick={deleteActionWindow}
        >
          <MediumText>Видалити</MediumText>
        </Button>
      </Block>
    </BodyDiv>
  );
}
